import { XDropdownSelectionContent } from '@adornis/popover/x-dropdown-selection.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-dropdown-selection-content
 */
@customElement('cr-dropdown-selection-content')
export class ChromiumDropdownSelectionContent extends XDropdownSelectionContent {
  override styles() {
    const superStyles = super.styles();
    delete superStyles[0]?.[':host'].boxShadow;
    return [
      ...superStyles,
      {
        ':host': {
          transform: `translateY(-10px)`,
          borderRadius: `0 0 ${this.sizes.borderRadiusSecondary} ${this.sizes.borderRadiusSecondary} `,

          boxShadow: `0px 18px 18px 3px ${this.colors.neutral.shade(600)}`,
        },

        [`::slotted(*:hover)`]: { background: `${this.colors.primary.shade(300)} !important` },
        [`::slotted([selected])`]: { background: `${this.colors.primary.shade(300)} !important` },
      },
    ];
  }
}
